import { render, staticRenderFns } from "./PersonalityResultsCompact.vue?vue&type=template&id=e70b8030"
import script from "./PersonalityResultsCompact.vue?vue&type=script&lang=js"
export * from "./PersonalityResultsCompact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports